<template>
  <div class="tender-chapter" :chapter="chapter.Title">
    <tender-section
      v-for="(section, i) in sections" :key="i"
      v-show="section.showContent !== false"
      :chapter-index="chapterIndex"
      :section-index="i"
    ></tender-section>
  </div>
</template>
<script>
import TenderSection from './section'
import { mapGetters } from 'vuex'
export default {
  name: 'TenderChapter',
  components: {
    TenderSection
  },
  props: {
    chapterIndex: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters(['chapters']),
    chapter() {
      return this.chapters[this.chapterIndex]
    },
    sections() {
      return this.chapter.Sections
    }
  }
}
</script>
<style lang="scss" scoped>
.tender-chapter {
  width: 900px;
  margin: 0 auto;
  box-sizing: border-box;
  .tc-title {
    font: bold 25px/30px simsun;
    text-align: center;
  }
}
</style>